import { render, staticRenderFns } from "./tracking.vue?vue&type=template&id=2c38d532&scoped=true&"
import script from "./tracking.vue?vue&type=script&lang=js&"
export * from "./tracking.vue?vue&type=script&lang=js&"
import style0 from "./tracking.vue?vue&type=style&index=0&id=2c38d532&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c38d532",
  null
  
)

export default component.exports